import {
  TAX_SUMMARY_FETCHING,
  TAX_SUMMARY_SUCCESS,
  TAX_SUMMARY_FAILED,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case TAX_SUMMARY_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case TAX_SUMMARY_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case TAX_SUMMARY_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
